var pantSizeChartFooter = [
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 30,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 30.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 31,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 31.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 32,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 32.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 33,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 33.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 34,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 34.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 35,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 35.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 36,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 36.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 37,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 37.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 38,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 38.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 39,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 39.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 13.5,
    sleeve_length: 40,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 30,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 30.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 31,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 31.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 32,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 32.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 33,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 33.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 34,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 34.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 35,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 35.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 36,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 36.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 37,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 37.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 38,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 38.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 39,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 39.5,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 14,
    sleeve_length: 40,
    chest: 19.3,
    waist: 17.75,
    bottom: 19.3,
    yoke: 16.85,
    biceps: 8,
    cuff: 8.25,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 30,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 30.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 31,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 31.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 32,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 32.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 33,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 33.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 34,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 34.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 35,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 35.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 36,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 36.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 37,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 37.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 38,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 38.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 39,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 39.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 14.5,
    sleeve_length: 40,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 30,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 30.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 31,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 31.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 32,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 32.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 33,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 33.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 34,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 34.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 35,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 35.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 36,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 36.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 37,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 37.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 38,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 38.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 39,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 39.5,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 15,
    sleeve_length: 40,
    chest: 20.9,
    waist: 19.3,
    bottom: 20.9,
    yoke: 17.65,
    biceps: 8.4,
    cuff: 8.5,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 30,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 30.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 31,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 31.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 32,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 32.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 33,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 33.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 34,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 34.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 35,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 35.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 36,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 36.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 37,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 37.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 38,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 38.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 39,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 39.5,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 15.5,
    sleeve_length: 40,
    chest: 22,
    waist: 20.5,
    bottom: 22,
    yoke: 18.45,
    biceps: 8.75,
    cuff: 9,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 30,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 30.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 31,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 31.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 32,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 32.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 33,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 33.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 34,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 34.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 35,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 35.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 36,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 36.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 37,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 37.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 38,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 38.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 39,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 39.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 16,
    sleeve_length: 40,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 30,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 30.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 31,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 31.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 32,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 32.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 33,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 33.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 34,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 34.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 35,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 35.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 36,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 36.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 37,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 37.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 38,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 38.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 39,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 39.5,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 16.5,
    sleeve_length: 40,
    chest: 23.25,
    waist: 21.65,
    bottom: 23.25,
    yoke: 19.2,
    biceps: 9.25,
    cuff: 9.25,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 30,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 30.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 31,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 31.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 32,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 32.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 33,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 33.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 34,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 34.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 35,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 35.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 36,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 36.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 37,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 37.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 38,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 38.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 39,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 39.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 17,
    sleeve_length: 40,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 30,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 30.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 31,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 31.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 32,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 32.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 33,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 33.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 34,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 34.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 35,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 35.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 36,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 36.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 37,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 37.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 38,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 38.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 39,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 39.5,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 17.5,
    sleeve_length: 40,
    chest: 24.8,
    waist: 23.25,
    bottom: 24.8,
    yoke: 20,
    biceps: 9.5,
    cuff: 9.6,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 30,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 30.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 31,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 31.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 32,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 28,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 32.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 33,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 33.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 34,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 34.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 35,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 35.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 36,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 36.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 32,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 37,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 37.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 33,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 38,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 38.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 34,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 39,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 39.5,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 35,
  },
  {
    fit_type: "Slim Fit",
    collar: 18,
    sleeve_length: 40,
    chest: 26.4,
    waist: 24.8,
    bottom: 26.4,
    yoke: 20.8,
    biceps: 10,
    cuff: 10.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 30,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 30.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 31,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 31.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 32,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 32.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 33,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 33.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 34,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 34.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 35,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 35.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 36,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 36.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 37,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 37.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 38,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 38.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 39,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 39.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 13.5,
    sleeve_length: 40,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 30,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 30.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 31,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 31.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 32,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 32.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 33,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 33.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 34,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 34.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 35,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 35.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 36,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 36.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 37,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 37.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 38,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 38.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 39,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 39.5,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 14,
    sleeve_length: 40,
    chest: 20,
    waist: 18.5,
    bottom: 19.75,
    yoke: 17.3,
    biceps: 8.25,
    cuff: 8.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 30,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 30.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 31,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 31.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 32,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 32.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 33,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 33.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 34,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 34.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 35,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 35.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 36,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 36.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 37,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 37.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 38,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 38.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 39,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 39.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 14.5,
    sleeve_length: 40,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 30,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 30.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 31,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 31.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 32,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 32.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 33,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 33.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 34,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 34.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 35,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 35.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 36,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 36.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 37,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 37.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 38,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 38.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 39,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 39.5,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 15,
    sleeve_length: 40,
    chest: 21.25,
    waist: 19.75,
    bottom: 21,
    yoke: 18.1,
    biceps: 8.62,
    cuff: 8.5,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 30,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 30.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 31,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 31.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 32,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 32.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 33,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 33.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 34,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 34.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 35,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 35.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 36,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 36.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 37,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 37.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 38,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 38.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 39,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 39.5,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 15.5,
    sleeve_length: 40,
    chest: 22.5,
    waist: 21,
    bottom: 22,
    yoke: 18.9,
    biceps: 9,
    cuff: 9,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 30,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 30.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 31,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 31.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 32,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 32.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 33,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 33.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 34,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 34.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 35,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 35.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 36,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 36.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 37,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 37.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 38,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 38.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 39,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 39.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 16,
    sleeve_length: 40,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 30,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 30.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 31,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 31.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 32,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 32.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 33,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 33.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 34,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 34.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 35,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 35.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 36,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 36.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 37,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 37.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 38,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 38.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 39,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 39.5,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 16.5,
    sleeve_length: 40,
    chest: 23.65,
    waist: 22,
    bottom: 23.25,
    yoke: 19.7,
    biceps: 9.38,
    cuff: 9.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 30,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 30.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 31,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 31.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 32,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 32.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 33,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 33.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 34,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 34.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 35,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 35.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 36,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 36.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 37,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 37.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 38,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 38.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 39,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 39.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 17,
    sleeve_length: 40,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 30,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 30.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 31,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 31.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 32,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 32.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 33,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 33.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 34,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 34.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 35,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 35.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 36,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 36.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 37,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 37.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 38,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 38.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 39,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 39.5,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 17.5,
    sleeve_length: 40,
    chest: 25.2,
    waist: 23.65,
    bottom: 24.4,
    yoke: 20.5,
    biceps: 9.75,
    cuff: 9.6,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 30,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 30.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 26.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 31,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 31.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 27.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 32,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 28,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 32.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 28.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 33,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 33.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 29.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 34,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 34.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 30.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 35,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 35.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 36,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 31.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 36.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 32,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 37,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 32.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 37.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 33,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 38,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 33.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 38.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 34,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 39,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 34.5,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 39.5,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    collar: 18,
    sleeve_length: 40,
    chest: 26.75,
    waist: 24.8,
    bottom: 25.6,
    yoke: 21.25,
    biceps: 10.25,
    cuff: 10.25,
    shirt_length: 35,
  },
  {
    fit_type: "Regular Fit",
    size: "S",
    neck: 15.25,
    chest: 20.75,
    waist: 20.75,
    bottom: 20.75,
    yoke: 17.75,
    biceps: 7.5,
    armhole: 10.5,
    sleeve_length: 24.75,
    cuff: 8.75,
    shirt_length: 29,
  },
  {
    fit_type: "Regular Fit",
    size: "M",
    neck: 16.25,
    chest: 21.75,
    waist: 21.75,
    bottom: 21.75,
    yoke: 19,
    biceps: 8,
    armhole: 10.75,
    sleeve_length: 25.5,
    cuff: 9,
    shirt_length: 30,
  },
  {
    fit_type: "Regular Fit",
    size: "L",
    neck: 17,
    chest: 23.25,
    waist: 23.25,
    bottom: 23.25,
    yoke: 19.75,
    biceps: 9,
    armhole: 11.5,
    sleeve_length: 25.75,
    cuff: 9.5,
    shirt_length: 31,
  },
  {
    fit_type: "Regular Fit",
    size: "XL",
    neck: 17.25,
    chest: 24.25,
    waist: 24.25,
    bottom: 24.25,
    yoke: 20,
    biceps: 9.5,
    armhole: 12,
    sleeve_length: 25.75,
    cuff: 9.5,
    shirt_length: 31.5,
  },
  {
    fit_type: "Slim Fit",
    size: "S",
    neck: 15.25,
    chest: 20,
    waist: 19.5,
    bottom: 20,
    yoke: 17.25,
    biceps: 7,
    armhole: 10,
    sleeve_length: 24.75,
    cuff: 8.5,
    shirt_length: 29,
  },
  {
    fit_type: "Slim Fit",
    size: "M",
    neck: 16.25,
    chest: 21,
    waist: 20.5,
    bottom: 21,
    yoke: 18.5,
    biceps: 7.5,
    armhole: 10.25,
    sleeve_length: 25.5,
    cuff: 8.75,
    shirt_length: 30,
  },
  {
    fit_type: "Slim Fit",
    size: "L",
    neck: 17,
    chest: 22.5,
    waist: 22,
    bottom: 22.5,
    yoke: 19.25,
    biceps: 8.5,
    armhole: 11,
    sleeve_length: 25.75,
    cuff: 9.25,
    shirt_length: 31,
  },
  {
    fit_type: "Slim Fit",
    size: "XL",
    neck: 17.25,
    chest: 23.5,
    waist: 23,
    bottom: 23.5,
    yoke: 19.5,
    biceps: 9,
    armhole: 11.5,
    sleeve_length: 25.75,
    cuff: 9.25,
    shirt_length: 31.5,
  },
];
